import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {Col, Row} from 'reactstrap';
import ManualList from 'manuals/containers/ManualList';
import CategoryControls from 'manuals/containers/CategoryControls';
import CategoryList from 'manuals/containers/CategoryList';
import {loadCategoryList} from 'manuals/actions/category';

export const filterCategoryList = (categoryList = [], searchText = '') => {
    if (searchText !== '') {
        return categoryList.filter(
            category => category.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
        )
    }
    return categoryList
}

@connect(
    state => ({
        isLoading: state.manuals.isLoading,
        searchText: state.manuals.searchText,
        categoryList: state.manuals.categoryList
    }),
    dispatch => {
        return {
            loadCategoryList: () => dispatch(loadCategoryList()),
        }
    }
)
export default class Main extends Component {

    componentDidMount() {
        this.props.loadCategoryList()
    }

    render() {
        const {
            isLoading,
            categoryList,
            searchText
        } = this.props;

        if (isLoading)
            return <Loading/>;

        return <Fragment>
            <CategoryControls/>
            <Row>
                <Col sm={4}>
                    <CategoryList categoryList={filterCategoryList(categoryList, searchText)}/>
                </Col>
                <Col sm={8}>
                    <ManualList/>
                </Col>
            </Row>
        </Fragment>
    }
}
